<div class="cms-page">
  <p-toast></p-toast>
  <span class="page-focus-trap" tabindex="-1" aria-hidden="true"></span>
  <div class="page-header">
    <div class="page-header__top">
      <h1 class="page-title">Services</h1>
      <p-button label="Add Service" icon="pi pi-plus" (onClick)="onAddService()" />
    </div>
    <div class="page-header__filters">
      <p-select-button
        [options]="labelOptions()"
        [ngModel]="displayedSelection()"
        (ngModelChange)="onLabelFilterChange($event)"
        optionLabel="label"
        optionValue="value"
        [multiple]="true"
        size="small"
      />
    </div>
  </div>
  <div
    class="page-body"
    cdkDropList
    cdkDropListOrientation="mixed"
    [cdkDropListData]="filteredServices()"
    (cdkDropListDropped)="onDrop($event)"
  >
    @for (service of filteredServices(); track service._cardId) {
      <div class="page-card-item" cdkDrag [cdkDragData]="service">
        <lib-cms-card
          [service]="service"
          (serviceChange)="onServiceChange(service._cardId, $event)"
          (deleteService)="onDeleteService(service._cardId)"
        />
      </div>
    } @empty {
      <p class="page-empty">No services match the selected filters.</p>
    }
  </div>
  <div class="page-footer">
    <p-button label="Publish" [disabled]="hasInvalidCards()" (onClick)="onPublish()" />
  </div>
</div>
